export default __webpack_public_path__ + "static/media/service-decor.c56652ca.png";